import { SecurityColumnVisibility } from '../../../../features/clients/client/portfolio/overview/store/types';
import { PortfolioPreferences, PreferenceUpgrader } from '../../types';

/**
 * These are the system default / initial columns - DO NOT MODIFY THESE!
 *
 * Adding a new column will require a migration, example:
 *
 * 1. Add the new optional column to the SecurityColumnVisibility type
 * e.g. `myNewField?: boolean`
 *
 * 2. Add a new migration step
 *
 * Step: (old) => ({
 *   ...old,
 *   defaultColumns: {
 *     ...old.defaultColumns,
 *     myNewField: old.defaultColumns?.myNewField ?? true,
 *   },
 *   version: 3,
 * }),
 *
 * 3. Bump latestVersion to 3
 * latestVersion: 3
 *
 * 4. Update unit tests.
 */
const defaultColumnVisibility: SecurityColumnVisibility = {
  name: true,
  securityCode: true,
  units: true,
  costBase: true,
  unitCost: true,
  unitPrice: true,
  nativePrice: false,
  currentValue: true,
  nativeValue: false,
  currentWeightPercentage: true,
  gainLossPercentage: true,
  returnSinceInception: true,
  returnSinceInceptionPercentage: true,
  gainLossValue: true,
  estimatedIncome: true,
  estimatedYield: true,
  estimatedGrossIncome: false,
  estimatedGrossYield: false,
  priceDate: true,
  currencyCode: false,
  forexRate: false,
};

const portfolioPreferencesMigration: PreferenceUpgrader<PortfolioPreferences> = {
  latestVersion: 2,
  steps: {
    // v0 -> v1: introduce `defaultView` with a 'compact' default when it has not been set.
    0: (old) => ({ ...old, defaultView: old.defaultView ?? 'compact', version: 1 }),

    // v1 -> v2: introduce `defaultColumns` with the standard column visibility defaults.
    1: (old) => ({ ...old, defaultColumns: old.defaultColumns ?? defaultColumnVisibility, version: 2 }),
  },
};

export default portfolioPreferencesMigration;
